import { Campaign } from '@domain/campaigns/campaigns.types';
import { Segments } from '../segments.types';

export const getSegmentWithTagEdited = (
    modalSelectedGroup:Segments, taggedCampaign: Campaign, newTag: string,
) => {
    const { taggedCampaigns } = modalSelectedGroup;
    const { campaign_id: campaignId } = taggedCampaign;

    if (!newTag) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [campaignId]: deleted, ...rest } = taggedCampaigns;
        return {
            ...modalSelectedGroup,
            taggedCampaigns: {
                ...rest,
            },
        };
    }

    const isNewCampaignTagged = !Object.prototype.hasOwnProperty.call(
        modalSelectedGroup.taggedCampaigns, campaignId,
    );
    const newTaggedCampaign = isNewCampaignTagged
        ? taggedCampaign : taggedCampaigns[campaignId];
    const editedCampaign = {
        id: newTaggedCampaign?.id,
        platform: newTaggedCampaign.platform,
        campaign_id: newTaggedCampaign.campaign_id,
        sublevel_id: newTaggedCampaign.sublevel_id,
        tags: [newTag],
    };

    return {
        ...modalSelectedGroup,
        taggedCampaigns: {
            ...taggedCampaigns,
            [campaignId]: editedCampaign,
        },
    };
};
